import React, { useEffect, useState } from 'react';
import { noop } from 'lodash';
import { DeveloperFiltersState } from 'store/state/app';
import FiltersDropdown from './FiltersDropdown';
import FiltersModal from './FiltersModal';
import { countFilters } from 'screens/DeveloperPage/components/filters/helpers';


interface FiltersProps {
  filters: DeveloperFiltersState;
  setFilters: (filters: DeveloperFiltersState) => void;
  isModal?: boolean;
  closeModal?: () => void;
}

const Filters: React.FC<FiltersProps> = (props) => {
  const { filters, setFilters, isModal } = props;
  const closeModal = 'closeModal' in props ? props.closeModal : noop;
  const [ filtersState, setFiltersState ] = useState(null);
  const activeFilters = countFilters(filters);

  useEffect(() => {
    setFiltersState(filters);
  }, [ filters ]);

  const onSubmit = () => setFilters(filtersState);
  const onClear = () => {
    if (!filters) setFiltersState(null);
    setFilters(null);
  };
  const onClose = () => setFilters(filters);

  return (
    <div>
      {isModal ? (
        <FiltersModal
          filters={filtersState}
          setFilters={setFiltersState}
          onSubmit={onSubmit}
          onClear={onClear}
          onClose={onClose}
          closeModal={closeModal}
        />
      ) : (
        <FiltersDropdown
          filters={filtersState}
          setFilters={setFiltersState}
          onSubmit={onSubmit}
          onClear={onClear}
          activeFilters={activeFilters}
          onClose={onClose}
        />
      )}
    </div>
  );
};

export default React.memo(Filters);
